import React, { Component } from "react";
import { compose } from "recompose";
import time from "src/utils/time";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Flex, Box, Spinner } from "@chakra-ui/react";
import { Activities } from "src/modules/activity-log/activity";
import { withParentStation } from "src/modules/parent-station/ParentStation/Context";
import { getVideoMode } from "src/duck/selectors";
import { getAvatarById } from "src/modules/avatar/duck/selectors";
import { withFrame } from "src/components/Frame/Context";
import NoiseIndicator from "src/modules/station/components/NoiseIndicator";
import MotionIndicator from "src/modules/station/components/MotionIndicator";
import { Subtitle } from "src/atoms/typography";
import LastEventSubtitle from "../components/LastEventSubtitle";
import ErrorMode from "./components/ErrorMode";
import ShadowGradients from "./components/ShadowGradients";
import SeeMeVideoPreview from "./components/SeeMeVideoPreview";
import { DarkMode } from "src/styling/Modes";

class VideoMode extends Component {
  videoRef = React.createRef();

  componentDidMount = () => {
    const { babyStation } = this.props;
    const { remoteVideoStream } = babyStation;

    if (this.videoRef.current == null) return;
    if (this.videoRef.current.srcObject !== remoteVideoStream) {
      this.videoRef.current.srcObject = remoteVideoStream;
    }
  };

  componentDidUpdate() {
    const { babyStation } = this.props;
    const { remoteVideoStream } = babyStation;

    if (this.videoRef.current == null) return;
    if (this.videoRef.current.srcObject !== remoteVideoStream) {
      this.videoRef.current.srcObject = remoteVideoStream;
    }
  }

  render() {
    const {
      t,
      babyStation,
      lastNoiseBefore,
      toggleActivityLog,
      monitoringStatusBar,
      lastMotionBefore,
      isInDetachMode,
      isInTileView,
      avatarNamePosition,
      frame,
      avatar,
      videoMode: globalVideoMode,
      parentStation
    } = this.props;
    const {
      activity,
      seeMeState,
      localVideoStream,
      remotePreviewAspectRatio,
      remoteVideoStream,
      videoError,
      noiseMeter,
      videoMode
    } = babyStation;

    const waitingForVideo = remoteVideoStream == null;
    const lastNoiseInMs = lastNoiseBefore;
    const lastMotionInMs = lastMotionBefore;

    const renderLastNoise =
      (!lastMotionBefore && lastNoiseBefore) || (lastMotionBefore && lastNoiseBefore && lastMotionInMs > lastNoiseInMs);

    const renderLastMotion =
      (lastMotionBefore && !lastNoiseBefore) || (lastMotionBefore && lastNoiseBefore && lastMotionInMs < lastNoiseInMs);
    return (
      <>
        {!isInDetachMode && <ShadowGradients activity={activity} lastNoiseBefore={lastNoiseBefore} />}
        {avatar && isInTileView && (
          <Flex
            width="100%"
            justifyContent="center"
            maxWidth="calc(100% - 146px)"
            position="absolute"
            top="11px"
            {...avatarNamePosition}
          >
            <Subtitle overflowX="hidden" whiteSpace="nowrap" textOverflow="ellipsis" color="white">
              {avatar.name}
            </Subtitle>
          </Flex>
        )}
        {waitingForVideo && (
          <Box transform="translateX(-50%)" position="absolute" top="50%" left="50%">
            <Spinner size="lg" />
          </Box>
        )}
        <video
          className={`baby-video-${babyStation.jid}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: videoMode || globalVideoMode || "cover",
            background: "#121212"
          }}
          ref={this.videoRef}
          autoPlay
          muted
          // eslint-disable-next-line react/no-unknown-property
          onResize={() => parentStation.videoUpdater.updateForStation(babyStation)}
        />
        <ErrorMode videoError={videoError} />
        <Flex
          flexDirection="column"
          alignItems="start"
          bg="transparent"
          width="100%"
          position="absolute"
          top={(frame ? frame.height : 39) + "px"}
          left="0px"
        >
          <Box width="100%" px="14px" mt="12px">
            {monitoringStatusBar}
          </Box>
          {seeMeState === "on" && (
            <Box mt="12px" ml="14px">
              <SeeMeVideoPreview
                localVideoStream={localVideoStream}
                remotePreviewAspectRatio={remotePreviewAspectRatio}
              />
            </Box>
          )}
        </Flex>
        <Box position="absolute" bottom="14px" left="50%" transform="translate(-50%)">
          {activity === Activities.AWAKE && noiseMeter && (
            <DarkMode>
              <NoiseIndicator mode="video" noiseMeter={noiseMeter} colorFirstTwoDots={false} />
            </DarkMode>
          )}
          {activity === Activities.MOTION && <MotionIndicator mode="video" />}
          {activity === Activities.SLEEPING && renderLastNoise && !isInDetachMode && (
            <LastEventSubtitle
              isInTileView={isInTileView}
              alignItems="center"
              onClick={toggleActivityLog}
              subtitle={t("parentStation.monitor.lastNoise", {
                value0:
                  lastNoiseBefore < 60000 ? t("activityLog.momentAgo.text") : time.duration(-lastNoiseBefore).humanize()
              })}
              color="white"
              fill="white"
              css={isInTileView ? { whiteSpace: "nowrap" } : {}}
            />
          )}
          {activity === Activities.SLEEPING && renderLastMotion && !isInDetachMode && (
            <LastEventSubtitle
              isInTileView={isInTileView}
              alignItems="center"
              onClick={toggleActivityLog}
              subtitle={t("monitor.lastMotion", {
                value0:
                  lastMotionBefore < 60000
                    ? t("activityLog.momentAgo.text")
                    : time.duration(-lastMotionBefore).humanize()
              })}
              color="white"
              fill="white"
              css={isInTileView ? { whiteSpace: "nowrap" } : {}}
            />
          )}
        </Box>
      </>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    avatar: getAvatarById(state, props.avatarId),
    videoMode: getVideoMode(state)
  };
}

const enhance = compose(withParentStation, withFrame, connect(mapStateToProps), withTranslation());

export default enhance(VideoMode);
